module.exports = __webpack_public_path__ + "static/media/michael-mroczek-195362-unsplash.f9971d70.jpg";